class BuilderBundle extends HTMLElement {
  constructor() {
    super()
    this.collectionWrapperSelector = '[js-collection-list-item]';
    this.productWrapperSelector = '[js-product-wrapper]';
    this.selectProductBtnSelector = '[js-select-product-btn]';
    this.bundleDataSelector = '[js-bundle-item]';
    this.selectionBoxSelector = '[js-selection-box]';
    this.selectionBoxListSelector = '[js-selection-box-list]';
    this.totalPriceSelector = '[js-product-price]';
    this.comparePriceSelector = '[js-product-compare-price]';
    this.selectionCountSelector = '[js-product-count]';
    this.addToCartBtn = this.querySelector('[js-bundle-atc-btn]');
    this.bundleTabHeader = '[js-bundle-tab-header]';
    this.collectionTabHeader = '[js-collection-tab-header]';
    this.collectionTabItem = '[js-collection-tab-item]';
    this.cardHeader = this.querySelector('[js-bundle-card-header]');
    this.cardDetail = this.querySelector('[js-budle-card-detail]');
    this.productsMap = new Map();
    this.productUsageMap = new Map();
    
  }

  connectedCallback() {
      this.discountPercentage = parseFloat(this.dataset.discountPrice || 0);
      this.initTabHeaders();
      this.setupBundleCardToggle();
      this.initializeBundleItems();
      this.initCollectionTabs();
      this.bindInitialProductEvents();
      this.bindCardTabEvent();
      this.bindRemoveProductEvents();
      this.updateTotalPrice();
      this.updateAddToCartVisibility();
      this.rebindPaginationLinks(this);

      this.addToCartBtn?.addEventListener('click', () => this.addBundleToCart());
  }
  initTabHeaders() {
    this.querySelectorAll('[js-bundle-tab-header]').forEach((header, index) => {
      header.addEventListener('click', () => {
        if (header.classList.contains('is-active')) return;

        this.querySelectorAll('[js-bundle-tab-header]').forEach(h => h.classList.remove('is-active'));
        this.querySelectorAll('[js-bundle-tab-item]').forEach(item => item.classList.remove('is-active'));

        header.classList.add('is-active');
        const tabContent = this.querySelectorAll('[js-bundle-tab-item]')[index];
        if (tabContent) tabContent.classList.add('is-active');
      });
    });
  }

  initializeBundleItems() {
    const bundleItems = this.querySelectorAll(this.bundleDataSelector);
    bundleItems.forEach((bundleItem, index) => {
      const initialBox = index < 2 ? 2 : 1;
      this.createBox(bundleItem, initialBox);
      this.productsMap.set(index, []);
    });
  }
  initCollectionTabs() {
    this.querySelectorAll(this.collectionTabHeader).forEach(tabHeader => {
      tabHeader.addEventListener('click', (evt) => {
        evt.preventDefault();

        const activeTab = evt.currentTarget.closest('.is-active');
        const headersInActiveTab = activeTab.querySelectorAll(this.collectionTabHeader);
        const wrapper = activeTab.querySelector(this.collectionTabItem);

        wrapper?.classList.add('is-fetching');
        headersInActiveTab.forEach(header => header.classList.remove('active'));
        evt.currentTarget.classList.add('active');

        const handle = evt.currentTarget.dataset.collectionHandle;

        fetch(`/collections/${handle}?section_id=bundle-collection-ajex`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector(this.collectionTabItem);

            if (newContent && wrapper) {
              wrapper.innerHTML = newContent.innerHTML;
              this.bindProductEvents(wrapper);
              this.rebindPaginationLinks(this);
            }
          })
          .finally(() => {
            wrapper?.classList.remove('is-fetching');
          });
      });
    });
  }
  bindCardTabEvent() {
    this.querySelectorAll(this.selectionBoxSelector).forEach(selectBoxTab => {
        selectBoxTab.addEventListener('click', () => {
            if (selectBoxTab.classList.contains('filled')) {
                e.preventDefault();  
                return; 
            }
            const cardTabEl = selectBoxTab.closest(this.bundleDataSelector);
            if (!cardTabEl) return;

            const cardTabElIndex = Number(cardTabEl.dataset.bundleItem);

            this.querySelectorAll(`${this.bundleTabHeader}`).forEach(tabHeader => {
                const headerIndex = Number(tabHeader.dataset.collectionTabItem);

                if (headerIndex === cardTabElIndex) {
                    if (!tabHeader.classList.contains('is-active')) {
                        tabHeader.classList.add('is-active');
                    }
                } else {
                    tabHeader.classList.remove('is-active');
                }
            });

            this.querySelectorAll(`${this.collectionWrapperSelector}`).forEach(tabContent => {
                const contentIndex = Number(tabContent.dataset.collectionListItem);
                const tabContentInner = tabContent.querySelector('[js-bundle-tab-item]');

                if (contentIndex === cardTabElIndex) {
                    if (!tabContentInner.classList.contains('is-active')) {
                        tabContentInner.classList.add('is-active');
                    }
                } else {
                    tabContentInner.classList.remove('is-active');
                }
            });
            if (this.cardHeader && this.cardDetail ) {
              this.cardHeader.classList.remove('is-visible');
              this.cardDetail.classList.remove('is-visible');
            }

        });
    });
  } 
  bindInitialProductEvents() {
    this.querySelectorAll(this.selectProductBtnSelector).forEach(selectProductBtn => {
      selectProductBtn.addEventListener('click', () => {
        const productElement = selectProductBtn.closest(this.productWrapperSelector);
        if (!productElement) return;

        const collectionElement = selectProductBtn.closest(this.collectionWrapperSelector);
        if (!collectionElement) return;

        const collectionIndex = Number(collectionElement.dataset.collectionListItem);
        const bundleItem = this.querySelector(`${this.bundleDataSelector}[data-bundle-item="${collectionIndex}"]`);
        if (!bundleItem) return;

        this.addProductToBox(bundleItem, productElement, collectionIndex);
        if (this.cardHeader && this.cardDetail) {
          this.cardHeader.classList.add('is-visible');
          this.cardDetail.classList.add('is-visible');
        }

      });
    });
  }
  bindRemoveProductEvents() {
    this.querySelectorAll('[js-product-remove-btn]').forEach(removeBtn => {
      removeBtn.addEventListener('click', () => {
        const productElement = removeBtn.closest(this.productWrapperSelector);
        if (!productElement) return;

        const productId = Number(productElement.dataset.productId);
        const collectionElement = removeBtn.closest(this.collectionWrapperSelector);
        if (!collectionElement) return;

        const collectionIndex = Number(collectionElement.dataset.collectionListItem);
        const bundleItem = this.querySelector(`${this.bundleDataSelector}[data-bundle-item="${collectionIndex}"]`);
        if (!bundleItem) return;

        const boxList = bundleItem.querySelector(this.selectionBoxListSelector);
        const targetBox = [...boxList.querySelectorAll(this.selectionBoxSelector)].find(
          box => Number(box.dataset.productId) === productId && box.classList.contains('filled')
        );

        if (!targetBox) return;

        targetBox.classList.remove('filled');
        targetBox.removeAttribute('data-product-id');
        targetBox.innerHTML = `
          <div class="bundle-builder__image product-card">
              <div class="bundle-builder__plus--icon">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.36784 4.69577V5.97577H5.63984V9.70377H4.35984V5.97577H0.631836V4.69577H4.35984V0.967773H5.63984V4.69577H9.36784Z" fill="black"/>
                  </svg>
              </div>
              <span class="bundle-builder__product-text">Produkt hinzufügen</span>
          </div>
        `;

        const updatedProducts = this.productsMap.get(collectionIndex).filter(p => p.id !== productId);
        this.productsMap.set(collectionIndex, updatedProducts);

        const currentCount = this.productUsageMap.get(productId) || 0;
        if (currentCount > 1) {
          this.productUsageMap.set(productId, currentCount - 1);
        } else {
          this.productUsageMap.delete(productId);
          const collectionElement = this.querySelector(`${this.collectionWrapperSelector}[data-collection-list-item="${collectionIndex}"]`);
          const productCard = collectionElement?.querySelector(`${this.productWrapperSelector}[data-product-id="${productId}"]`);
          if (productCard) {
            productCard.classList.remove('show-social');
          }
        }
        this.updatePerCardCount(collectionIndex);
        this.toggleTabButtonsDisabled(collectionIndex);
        this.cleanupExtraBoxes(bundleItem, collectionIndex);
        this.updateTotalPrice();
        this.bindCardTabEvent();
        this.updateAddToCartVisibility();
      });
    });
  }
  rebindPaginationLinks(container) {
    container.querySelectorAll('.pagination a').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const url = new URL(link.href);
        const activeTab = e.currentTarget.closest('.is-active');
        const wrapper = activeTab.querySelector(this.collectionTabItem);
        wrapper?.classList.add('is-fetching');

        fetch(`${url.pathname}${url.search}&section_id=bundle-collection-ajex`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector(this.collectionTabItem);

            if (newContent && wrapper) {
              wrapper.innerHTML = newContent.innerHTML;
              this.bindProductEvents(wrapper);
              this.rebindPaginationLinks(wrapper);
            }
          })
          .finally(() => {
            wrapper?.classList.remove('is-fetching');
          });
      });
    });
  }

  bindProductEvents(container) {
    container.querySelectorAll(this.selectProductBtnSelector).forEach(selectProductBtn => {
      selectProductBtn.addEventListener('click', () => {
        const productElement = selectProductBtn.closest(this.productWrapperSelector);
        if (!productElement) return;

        const collectionElement = selectProductBtn.closest(this.collectionWrapperSelector);
        if (!collectionElement) return;

        const collectionIndex = Number(collectionElement.dataset.collectionListItem);
        const bundleItem = this.querySelector(`${this.bundleDataSelector}[data-bundle-item="${collectionIndex}"]`);
        if (!bundleItem) return;

        this.addProductToBox(bundleItem, productElement, collectionIndex);
        if (this.cardHeader && this.cardDetail) {
          this.cardHeader.classList.add('is-visible');
          this.cardDetail.classList.add('is-visible');
        }
      });
    });

    container.querySelectorAll('[js-product-remove-btn]').forEach(removeBtn => {
      removeBtn.addEventListener('click', () => {
        const productElement = removeBtn.closest(this.productWrapperSelector);
        if (!productElement) return;

        const productId = Number(productElement.dataset.productId);
        const collectionElement = removeBtn.closest(this.collectionWrapperSelector);
        if (!collectionElement) return;

        const collectionIndex = Number(collectionElement.dataset.collectionListItem);
        const bundleItem = this.querySelector(`${this.bundleDataSelector}[data-bundle-item="${collectionIndex}"]`);
        if (!bundleItem) return;

        const boxList = bundleItem.querySelector(this.selectionBoxListSelector);
        const targetBox = [...boxList.querySelectorAll(this.selectionBoxSelector)].find(
          box => Number(box.dataset.productId) === productId && box.classList.contains('filled')
        );

        if (!targetBox) return;

        targetBox.classList.remove('filled');
        targetBox.removeAttribute('data-product-id');
        targetBox.innerHTML = `
          <div class="bundle-builder__image product-card">
            <div class="bundle-builder__plus--icon">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.36784 4.69577V5.97577H5.63984V9.70377H4.35984V5.97577H0.631836V4.69577H4.35984V0.967773H5.63984V4.69577H9.36784Z" fill="black"/>
              </svg>
            </div>
            <span class="bundle-builder__product-text">Produkt hinzufügen</span>
          </div>
        `;

        const updatedProducts = this.productsMap.get(collectionIndex).filter(p => p.id !== productId);
        this.productsMap.set(collectionIndex, updatedProducts);

        const currentCount = this.productUsageMap.get(productId) || 0;
        if (currentCount > 1) {
          this.productUsageMap.set(productId, currentCount - 1);
        } else {
          this.productUsageMap.delete(productId);
          const collectionElement = this.querySelector(`${this.collectionWrapperSelector}[data-collection-list-item="${collectionIndex}"]`);
          const productCard = collectionElement?.querySelector(`${this.productWrapperSelector}[data-product-id="${productId}"]`);
          if (productCard) {
            productCard.classList.remove('show-social');
          }
        }

        this.updatePerCardCount(collectionIndex);
        this.toggleTabButtonsDisabled(collectionIndex);
        this.cleanupExtraBoxes(bundleItem, collectionIndex);
        this.updateTotalPrice();
        this.bindCardTabEvent();
        this.updateAddToCartVisibility();
      });
    });

    // ✅ Add this at the end to restore visual state:
    this.productsMap.forEach((products, collectionIndex) => {
      const wrapper = this.querySelector(`${this.collectionWrapperSelector}[data-collection-list-item="${collectionIndex}"]`);
      if (!wrapper) return;

      // Add `show-social` to already selected product cards
      products.forEach(({ id }) => {
        const card = wrapper.querySelector(`${this.productWrapperSelector}[data-product-id="${id}"]`);
        if (card) card.classList.add('show-social');
      });

      // Disable select buttons if already 2 products selected
      if (products.length >= 2) {
        wrapper.querySelectorAll(this.selectProductBtnSelector).forEach(btn => {
          btn.classList.add('is-disabled');
        });
      }
    });
  }

  setupBundleCardToggle() {
      if (this.cardHeader && this.cardDetail) {
        this.cardHeader.addEventListener('click', () => {
          this.cardHeader.classList.toggle('is-visible');
          this.cardDetail.classList.toggle('is-visible');
        });
      }
  }


  createBox(bundleItem, count) {
    const boxList = bundleItem.querySelector(this.selectionBoxListSelector);
    if (!boxList) return;

    boxList.innerHTML = '';
    for (let i = 0; i < count; i++) {
      this.insertEmptyBox(boxList, i);
    }

    this.updateBundleCount(bundleItem);
  }

  insertEmptyBox(boxList, index) {
    boxList.insertAdjacentHTML('beforeend', `
      <div js-selection-box class="bundle-builder__box" data-index="${index}">
        <div class="bundle-builder__image product-card">
            <div class="bundle-builder__plus--icon">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.36784 4.69577V5.97577H5.63984V9.70377H4.35984V5.97577H0.631836V4.69577H4.35984V0.967773H5.63984V4.69577H9.36784Z" fill="black"/>
                </svg>
            </div>
            <span class="bundle-builder__product-text">Produkt hinzufügen</span>
        </div>
      </div>
    `);
  }

  addProductToBox(bundleItem, productElement, collectionIndex) {
    const productId = Number(productElement.dataset.productId);
    const imageUrl = productElement.dataset.productImageUrl;
    const title = productElement.dataset.productTitle;
    const price = Number(productElement.dataset.productPrice);
    const comparePrice = Number(productElement.dataset.productComparePrice) || 0;

    const formattedPrice = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
    const formattedComparePrice = theme.Currency.formatMoney(comparePrice, theme.settings.moneyFormat);
    const cardNotes = productElement.dataset.cardNotes;

    let products = this.productsMap.get(collectionIndex) || [];

    if (products.length >= 2) return;

    const boxList = bundleItem.querySelector(this.selectionBoxListSelector);
    let targetBox = [...boxList.querySelectorAll(this.selectionBoxSelector)]
      .find(box => !box.classList.contains('filled'));

    if (!targetBox) {
      const newIndex = boxList.querySelectorAll(this.selectionBoxSelector).length;
      this.insertEmptyBox(boxList, newIndex);
      targetBox = boxList.querySelector(`${this.selectionBoxSelector}[data-index="${newIndex}"]`);
    }

    targetBox.classList.add('filled');
    targetBox.setAttribute('data-product-id', productId);
    targetBox.innerHTML = `
      <div class="bundle-builder__image">
        <img src="${imageUrl}" alt="${title}" />
      </div>
      <button class="bundle-builder-beta__delete--icon remove-btn" aria-label="Remove Product">
         <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="1.39014" width="24" height="24" rx="12" fill="white"/>
            <rect x="0.630871" y="1.02101" width="24.7383" height="24.7383" rx="12.3691" stroke="#121212" stroke-opacity="0.2" stroke-width="0.738258"/>
            <mask id="mask0_3010_13977" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="6" y="6" width="14" height="15">
            <rect x="6.14453" y="6.53271" width="13.7143" height="13.7143" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_3010_13977)">
            <path d="M10.3202 18.2469C10.0353 18.2469 9.79187 18.146 9.58996 17.9442C9.38815 17.7423 9.28725 17.4989 9.28725 17.2139V9.9612H8.71582V9.10406H11.2872V8.59863H14.7158V9.10406H17.2872V9.9612H16.7158V17.2139C16.7158 17.5026 16.6158 17.7469 16.4158 17.9469C16.2158 18.1469 15.9715 18.2469 15.6828 18.2469H10.3202ZM15.8587 9.9612H10.1444V17.2139C10.1444 17.2653 10.1609 17.3074 10.1938 17.3403C10.2268 17.3733 10.2689 17.3898 10.3202 17.3898H15.6828C15.7268 17.3898 15.7671 17.3714 15.8037 17.3348C15.8403 17.2982 15.8587 17.2579 15.8587 17.2139V9.9612ZM11.5181 16.2469H12.3751V11.1041H11.5181V16.2469ZM13.628 16.2469H14.485V11.1041H13.628V16.2469Z" fill="#1C1B1F"/>
            </g>
        </svg>
      </button>
      <div class="bundle-builder__product--info">
        <h2 class="bundle-builder-beta__product--title">${title}</h2>
        <div class="bundle-builder__product--subtitle">${cardNotes}</div>
        <div class="bundle-builder__dummy--price">${formattedPrice}</div>
      </div>
    `;

    targetBox.querySelector('.remove-btn').addEventListener('click', () => {
      targetBox.classList.remove('filled');
      targetBox.removeAttribute('data-product-id');
      targetBox.innerHTML = `
        <div class="bundle-builder__image product-card">
            <div class="bundle-builder__plus--icon">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.36784 4.69577V5.97577H5.63984V9.70377H4.35984V5.97577H0.631836V4.69577H4.35984V0.967773H5.63984V4.69577H9.36784Z" fill="black"/>
                </svg>
            </div>
            <span class="bundle-builder__product-text">Produkt hinzufügen</span>
        </div>
      `;

      products = this.productsMap.get(collectionIndex).filter(p => p.id !== productId);
      this.productsMap.set(collectionIndex, products);
      const currentCount = this.productUsageMap.get(productId) || 0;
        if (currentCount > 1) {
            this.productUsageMap.set(productId, currentCount - 1);
        } else {
            this.productUsageMap.delete(productId);

            const collectionElement = this.querySelector(`${this.collectionWrapperSelector}[data-collection-list-item="${collectionIndex}"]`);
            const productCard = collectionElement?.querySelector(`${this.productWrapperSelector}[data-product-id="${productId}"]`);
            if (productCard) {
                productCard.classList.remove('show-social');
            }
        }

        this.updatePerCardCount(collectionIndex);
        this.toggleTabButtonsDisabled(collectionIndex);
        this.cleanupExtraBoxes(bundleItem, collectionIndex);
        this.updateTotalPrice();
        this.bindCardTabEvent();
        this.updateAddToCartVisibility();
        this.updatePerCardCount(collectionIndex);
    });

    products.push({ id: productId, title, price, comparePrice });
    this.productsMap.set(collectionIndex, products);

    const currentCount = this.productUsageMap.get(productId) || 0;
    this.productUsageMap.set(productId, currentCount + 1);

    const collectionElement = this.querySelector(`${this.collectionWrapperSelector}[data-collection-list-item="${collectionIndex}"]`);
    const productCard = collectionElement?.querySelector(`${this.productWrapperSelector}[data-product-id="${productId}"]`);
    if (productCard) {
    productCard.classList.add('show-social');
    }

    this.updatePerCardCount(collectionIndex);
    this.toggleTabButtonsDisabled(collectionIndex);
    this.updateBundleCount();
    this.updateTotalPrice();
    this.bindCardTabEvent();
    this.updateAddToCartVisibility();
    this.updatePerCardCount(collectionIndex);
  }

  toggleTabButtonsDisabled(collectionIndex) {
    const tab = this.querySelector(`${this.collectionWrapperSelector}[data-collection-list-item="${collectionIndex}"]`);
    if (!tab) return;

    const buttons = tab.querySelectorAll(this.selectProductBtnSelector);
    const products = this.productsMap.get(collectionIndex) || [];

    const shouldDisable = products.length >= 2;

    buttons.forEach(btn => {
      btn.classList.toggle('is-disabled', shouldDisable);
    });
  }
  updatePerCardCount(collectionIndex) {
    const bundleItem = this.querySelector(`${this.bundleDataSelector}[data-bundle-item="${collectionIndex}"]`);
    if (!bundleItem) return;

    const count = bundleItem.querySelectorAll(`${this.selectionBoxSelector}.filled`).length;
    const max = collectionIndex < 2 ? 2 : 1;

    const countEl = this.querySelector(`[js-bundle-box-count-${collectionIndex}]`);
    if (countEl) {
      countEl.textContent = `${count}/${max}`;
    }
  }
  updateBundleCount() {
    const countElements = this.querySelectorAll(this.selectionCountSelector);
    let totalFilled = 0;

    this.querySelectorAll(this.bundleDataSelector).forEach(bundleItem => {
      const filledBoxes = bundleItem.querySelectorAll(`${this.selectionBoxSelector}.filled`).length;
      totalFilled += filledBoxes;
    });

    const displayRight = 4; 

    countElements.forEach(countEl => {
      countEl.textContent = `(${totalFilled}/${displayRight})`;
    });
  }

    updateTotalPrice() {
        let totalOriginalPrice = 0;

        this.productsMap.forEach(products => {
            products.forEach(p => {
            totalOriginalPrice += p.price;
            });
        });

        const priceElement = this.querySelector(this.totalPriceSelector);
        const compareElement = this.querySelector(this.comparePriceSelector);
        
        const discountPercent = parseFloat(this.discountPercentage || 0);
        const discountAmount = (totalOriginalPrice * discountPercent) / 100;
        const finalPrice = totalOriginalPrice - discountAmount;
        
        if (priceElement) {
          priceElement.innerHTML = theme.Currency.formatMoney(finalPrice, theme.settings.moneyFormat);
        }

        if (compareElement) {
          compareElement.innerHTML = theme.Currency.formatMoney(totalOriginalPrice, theme.settings.moneyFormat);
          compareElement.classList.toggle('hidden', totalOriginalPrice <= 0);
        }
    }

  cleanupExtraBoxes(bundleItem, collectionIndex) {
    const defaultCount = collectionIndex < 2 ? 2 : 1;
    const boxList = bundleItem.querySelector(this.selectionBoxListSelector);
    const allBoxes = [...boxList.querySelectorAll(this.selectionBoxSelector)];

    allBoxes.forEach((box, index) => {
      const isFilled = box.classList.contains('filled');
      if (index >= defaultCount && !isFilled) {
        box.remove();
      }
    });

    this.updateBundleCount(bundleItem);
  }

  updateAddToCartVisibility() {
    if (!this.addToCartBtn) return;

    const first = this.productsMap.get(0)?.length || 0;
    const second = this.productsMap.get(1)?.length || 0;

    this.addToCartBtn.classList.toggle('is-visible', first >= 2 && second >= 2);
  }

  async addBundleToCart() {
    const items = [];
    this.productsMap.forEach((products) => {
      products.forEach((product) => {
        items.push({
          id: product.id,
          quantity: 1,
          properties: {
            _isBundle: true
          }
        });
      });
    });

    if (!items.length) return;
    this.addToCartBtn.classList.add('loading');

    const sections = ['variant-added'];

    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections }
    }));

    const requestBody = {
      items: items,
      sections: sections,
      sections_url: Shopify.routes.root
    };

    try {
      const discountRes = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        body: JSON.stringify({
          discount: this.dataset.discountCode
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      await discountRes.json();
      const resp = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody)
      });
      const responseJson = await resp.json();
      this.addToCartBtn.classList.remove('loading');

      if (resp.ok) {
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        this.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson],
            cart: cartContent
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));

        this.productsMap.clear();

        this.querySelectorAll(this.bundleDataSelector).forEach((bundleItem, index) => {
          const defaultBoxCount = index < 2 ? 2 : 1;
          this.createBox(bundleItem, defaultBoxCount);
        });

        this.querySelectorAll(this.collectionWrapperSelector).forEach(wrapper => {
          wrapper.querySelectorAll(this.productWrapperSelector).forEach(product => {
            product.classList.remove('show-social');
          });
          wrapper.querySelectorAll(this.selectProductBtnSelector).forEach(btn => {
            btn.classList.remove('is-disabled');
          });
        });

        this.querySelectorAll(this.bundleDataSelector).forEach((bundleItem, index) => {
          this.updatePerCardCount(index);
          this.toggleTabButtonsDisabled(index);
        });

        this.updateTotalPrice();
        this.bindCardTabEvent();
        this.updateBundleCount();
        this.updateAddToCartVisibility();
      } else {
        this.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson.description
          }
        }));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }

    } catch (err) {
      console.error('Bundle Add to Cart Error:', err);
      this.addToCartBtn.classList.remove('loading');
    }
  }
}

customElements.define('bundle-builder', BuilderBundle);
